module.exports = __webpack_public_path__ + "static/media/insta-icon-blue.13df391c.svg";